<template lang='pug'>
  .radio
    input.radio__input(
      v-model="valueInput"
      type='radio'
      :id="id"
      :disabled="disabled"
      :name="name"
      :value="option.value || option"
      @input="onInput($event.target.value)"
    )
    label.label(:for="id") {{ option.label || option }}
</template>

<script>
export default {
  name: 'Radio',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    option: {
      type: Object || String,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      valueInput: this.value,
      filled: false
    }
  },
  watch: {
    value (oldValue, newValue) {
      if (oldValue !== newValue) {
        this.valueInput = oldValue
        this.onInput(this.valueInput)
      }
    }
  },
  created () {
    if (this.value) this.filled = true
  },
  updated () {
    if (this.value) this.filled = true
  },
  methods: {
    onInput (value) {
      this.filled = Boolean(value)
      this.$emit('onChange', value)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .radio {
    display: inline-block;
    margin-right: 32px;
    margin-top: 8px;
    &__input {
      position: absolute;
      left: -9999px;
      & + .label {
        position: relative;
        padding-left: 32px;
        padding-top: 2px;
        cursor: pointer;
        font-family: $rubik-font-family;
        font-size: 16px;
        font-weight: 500;
        color: #444444;
        &:before {
          border: solid 1px #bdc2c6;
          border-radius: 100%;
          content: '';
          height: 18px;
          left: 0;
          transition: border-color 400ms, background-color 400ms;
          top: 0;
          position: absolute;
          width: 18px;
        }
        &:after {
          background-color: transparent;
          border-radius: 100%;
          content: '';
          height: 12px;
          left: 4px;
          position: absolute;
          top: 4px;
          transition: background-color 400ms;
          width: 12px;
        }
      }
      &:checked {
        & + .label {
          &:before {
            border-color: #1A71B4;
          }
          &:after {
            background-color: #1A71B4;
          }
        }
      }
      &:disabled {
        & + .label {
          cursor: no-drop;
          opacity: 0.4;
          &:before {
            opacity: 0.4;
          }
        }
      }
    }
  }
</style>
